export default __webpack_public_path__ + "static/media/demo-2.937285b9.png";